var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.337a3.695 3.695 0 0 1 3.687 3.686A3.694 3.694 0 0 1 12 15.71a3.694 3.694 0 0 1-3.687-3.687A3.695 3.695 0 0 1 12 8.337"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.25 1.5H6.75A5.26 5.26 0 0 0 1.5 6.75v10.5a5.26 5.26 0 0 0 5.25 5.25h10.5a5.26 5.26 0 0 0 5.25-5.25V6.75a5.26 5.26 0 0 0-5.25-5.25M12 6.75A5.26 5.26 0 0 0 6.75 12 5.26 5.26 0 0 0 12 17.25 5.26 5.26 0 0 0 17.25 12 5.26 5.26 0 0 0 12 6.75m4.503-.42c0-.653.537-1.19 1.19-1.19.654 0 1.19.537 1.19 1.19s-.536 1.19-1.19 1.19-1.19-.537-1.19-1.19",
    clipRule: "evenodd"
  })));
};
export default SvgInstagram;